export const RESET = 'EXSBPAYMENTWAY_UPDATE_RESET'
export const SET_ERROR = 'EXSBPAYMENTWAY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPAYMENTWAY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPAYMENTWAY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPAYMENTWAY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPAYMENTWAY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPAYMENTWAY_UPDATE_UPDATE_RETRIEVED'
